module.exports = __webpack_public_path__ + "media/assets/move_your_business_forward-4e4a6b517d76959c9b4ada0b584eaf09.svg";